module.exports = __webpack_public_path__ + "static/media/dropdown_click.3ab0d4e9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/dropdown_click.svg
// module id = 1223
// module chunks = 1